module.exports = __webpack_public_path__ + "static/media/search-zoom-in-black.fcec4484.svg";